module.exports = __webpack_public_path__ + "static/img/top2.6a127564.png";